/**
 * Created by IvanCai on 2017/4/19.
 * Modified by Zhi on 2018/7/8.
 */
import axios from 'axios';
import utils from '@/jslib/dk-utils';

import env from '@/configs/env';

const dkAxios = axios.create({
  baseURL: env.apiDomain,
  timeout: 10000, // 设置超时时间
});

let loading;
dkAxios.interceptors.request.use(
  (config) => {
    // 访问网络时加载loading,防止用户多次操作
    // const token = utils.getCookie('token')s;

    if (utils.getCookie('token')) {
      // eslint-disable-next-line
      config.headers = { 'X-Access-Token': utils.getCookie('token') };
    }

    loading = window.vm.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    console.log(loading, '====')
    return config;
  },
  // eslint-disable-next-line
  (error) => Promise.reject(error),
);

dkAxios.interceptors.response.use(
  (response) => {
    loading.close();
    return response;
  },
  (error) => {
    loading.close();
    const { status, data } = error.response;

    switch (status) {
      case 401:
      // case 403:
        window.vm.$router.replace('/login');
        break;
      default:
        window.vm.$message(data.error.message);
        return Promise.reject(error);
    }
    return error
  },
);

export default dkAxios;



// WEBPACK FOOTER //
// ./src/jslib/dk-axios.js